import { render, staticRenderFns } from "./insuredManagement.vue?vue&type=template&id=623198bd&scoped=true"
import script from "./insuredManagement.vue?vue&type=script&lang=js"
export * from "./insuredManagement.vue?vue&type=script&lang=js"
import style0 from "./insuredManagement.vue?vue&type=style&index=0&id=623198bd&prod&scoped=true&lang=css"
import style1 from "./insuredManagement.vue?vue&type=style&index=1&id=623198bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623198bd",
  null
  
)

export default component.exports